import { Avatar, Button } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { PaginationActiveBtn, PaginationDisabledBtn } from 'Images';

interface INextPrevButton {
  isPrev?: boolean;
  isActive?: boolean;
  callback: Function;
}

export const NextPrevButton = ({
  isPrev,
  isActive,
  callback,
}: INextPrevButton) => {
  const isDesktop = useIsDesktop();

  const nextPrevPaginateHandler = () => {
    callback();
    window.scroll({ behavior: 'smooth', top: 0 });
  };

  return (
    <Button
      disableTouchRipple={!isActive}
      sx={{
        minWidth: 0,
        width: 'fit-content',
        p: 0,
        ':hover': {
          cursor: isActive ? 'pointer' : 'not-allowed',
        },
      }}
      onClick={() => (isActive ? nextPrevPaginateHandler() : undefined)}
    >
      <Avatar
        alt=''
        src={isActive ? PaginationActiveBtn : PaginationDisabledBtn}
        sx={{
          width: isDesktop ? undefined : '32px',
          height: isDesktop ? undefined : '32px',
          transform: isActive
            ? isPrev
              ? 'rotate(180deg)'
              : undefined
            : isPrev
            ? undefined
            : 'rotate(180deg)',
        }}
      />
    </Button>
  );
};
